<template>
  <div class="post-purchase-modal">
    <HMModalHeader
      v-if="!hideHeader"
      :title="$t('PRODUCTS.TITLE.POST_PURCHASE_TITLE')"
      @close="close"
    />
    <h1 class="mb-4" v-if="isFreeProduct">
      {{ $t('PRODUCTS.TITLE.FREE_PRODUCT_REGISTRATION_SUCCESSFUL') }}
    </h1>
    <h1 class="mb-4" v-else>
      {{ $t('PRODUCTS.TITLE.PURCHASE_SUCCESSFUL') }}
    </h1>
    <p class="mt-4" v-if="isFreeProduct">
      {{
        $t('PRODUCTS.TEXT.PRODUCT_POST_REGISTRATION_TEXT', {
          product: product.product_name,
        })
      }}
    </p>
    <p class="mt-4" v-else>
      {{
        $t('PRODUCTS.TEXT.PRODUCT_POST_PURCHASE_TEXT', {
          product: product.product_name,
        })
      }}
    </p>
    <StudioProductCard :product="product" :static="true" :animated="false" />
    <HMButton class="w-100 text-center" color="brand">
      <router-link
        class="undecorated-router-link w-100"
        :to="{
          name: viewRouteName,
          params: {
            studio_url: studioURL,
            product_id: product.id,
            event_id: eventId,
          },
          query: { purchased: true },
        }"
        @click.native="close"
      >
        <span class="w-100 text-center">
          {{ $t(viewButtonText) }}
        </span>
      </router-link>
    </HMButton>
  </div>
</template>

<script>
import Vue from 'vue';
import StudioProductCard from '@/web/components/products/StudioProductCard.vue';
import Cookies from 'js-cookie';

export default Vue.extend({
  name: 'ProductPostPurchaseModal',
  components: {
    StudioProductCard,
  },
  props: {
    product: {
      type: Object,
    },
    studioURL: {
      type: String,
    },
    onClose: {
      type: Function,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    viewButtonText: {
      type: String,
      default: 'PRODUCTS.BUTTON.VIEW_PRODUCT',
    },
    viewRouteName: {
      type: String,
      default: 'studio-product',
    },
    eventId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    isFreeProduct() {
      return this.product.pricing_type === 'free';
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      Cookies.remove('checkouteventid');
      if (this.onClose) this.onClose();
      this.$emit('close');
    },
  },
  mounted() {
    if (this.eventId) {
      // redirect to the event page, so the registration can be processed
      this.close();
      this.$router.replace({
        name: this.viewRouteName,
        params: {
          studio_url: this.studioURL,
          event_id: this.eventId,
        },
        query: { purchased: true },
      });
    }
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
